module.exports = __webpack_public_path__ + "ico_mensaje_rechazadaCX.png";